import type { ReferralAttribution } from '../model/referral/referralAttribution';

export type { ReferralAttribution } from '../model/referral/referralAttribution';

export function normalizeReferralCode(value: string | null): string | null {
  const code = value?.trim().toUpperCase();
  return code && /^[A-Z0-9]{6,32}$/.test(code) ? code : null;
}

export function getReferralGeneration(
  attribution: ReferralAttribution | null,
  consumedAttribution: ReferralAttribution | null,
): number {
  return Math.max(attribution?.generation ?? 0, consumedAttribution?.generation ?? 0);
}

export function getReferralAttributionUpdate(
  current: ReferralAttribution | null,
  next: Pick<ReferralAttribution, 'actorId' | 'code'>,
  latestGeneration: number,
  incomingReplacedCodes: readonly string[] = [],
  freshArrival = false,
): Pick<Required<ReferralAttribution>, 'generation' | 'replacedCodes'> {
  return {
    generation:
      !freshArrival && current?.actorId === next.actorId && current.code === next.code
        ? (current.generation ?? 0)
        : latestGeneration + 1,
    replacedCodes: [
      ...new Set([...(current?.replacedCodes ?? []), ...(current ? [current.code] : []), ...incomingReplacedCodes]),
    ].filter((code) => code !== next.code),
  };
}

interface ReferralRequestContext {
  actorId: string | null;
  userId: string | undefined;
  intent?: number;
  generation?: number;
}

export function isReferralRequestCurrent(expected: ReferralRequestContext, current: ReferralRequestContext): boolean {
  return (
    expected.actorId === current.actorId &&
    expected.userId === current.userId &&
    (expected.intent === undefined || expected.intent === current.intent) &&
    (expected.generation === undefined || expected.generation === current.generation)
  );
}

export function selectReferralArrivalCode(
  result: { accepted: boolean; code?: string | null; requestedCode?: string | null },
  requestedCode: string,
): string | null {
  return result.accepted && result.code ? (result.requestedCode ?? requestedCode) : null;
}
